import axiosInstance from "../utils/ApiUtils/axiosInstance";
import { VersionInfo } from "../utils/appVersion";

export const fetchServerVersion = async (): Promise<VersionInfo> => {
  const response = await axiosInstance.get<ApiResponse<VersionInfo>>("/api/version");
  const info = response.data?.data;
  if (!info || typeof info.version !== "string") {
    throw new Error("The server returned invalid version data.");
  }
  return info;
};
